import { t } from "@/i18n-js/instance";
import { Filter, RadioFilter } from "@circle-react-shared/Filter";

interface TypeFilterProps {
  value: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
}

export const TypeFilter = ({ value, onChange, options }: TypeFilterProps) => {
  // Convert options to the format expected by RadioFilter
  const radioOptions = options.map(option => ({
    name: option.value,
    label: option.label,
    value: option.value,
  }));

  const selectedOptionLabel =
    options.find(opt => opt.value === value)?.label || "";

  return (
    <Filter
      chip={t("settings.community_bot.knowledge.filters.type_chip")}
      title={t("settings.community_bot.knowledge.filters.type_title")}
      selectedText={value}
      renderSelectedText={() => selectedOptionLabel}
      onApply={(val: string) => onChange(val || "")}
      isInitialOpen={false}
      shouldShowRemoveButton
    >
      <RadioFilter
        options={radioOptions}
        legend={t("settings.community_bot.knowledge.filters.type_legend")}
        name="type-filter"
      />
    </Filter>
  );
};
